import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import RswNavigator, {
  getNavigatorDescription,
  getNavigatorDetailsDescriptionOrNull,
} from "../../interfaces/robot/navigator";
import DemoModeNavigatorIcon from "../../images/navigator-icons/DemoModeNavigatorIcon.svg";
import RandomNavigatorIcon from "../../images/navigator-icons/RandomNavigatorIcon.svg";
import RandomWallFollowNavigatorIcon from "../../images/navigator-icons/RandomWallFollowNavigatorIcon.svg";
import RepeatPathDemoNavigatorIcon from "../../images/navigator-icons/RepeatPathDemoNavigatorIcon.svg";
import SpotCleaningNavigatorIcon from "../../images/navigator-icons/SpotCleaningNavigatorIcon.svg";
import OpenSpaceWallFollowNavigatorIcon from "../../images/navigator-icons/OpenSpaceWallFollowNavigatorIcon.svg";
import SubZonesNavigatorIcon from "../../images/navigator-icons/SubZonesNavigatorIcon.svg";
import WallFollowNavigatorIcon from "../../images/navigator-icons/WallFollowNavigatorIcon.svg";
import { NavigatorAvailability } from "../../enums/command-hub/navigator";

// needed because icon images have to be statically imported (instead of dynamic require) in order to no be removed in build
export const navigatorToNavigatorIconMap = [
  { navigatorKey: "Random", navigatorIcon: RandomNavigatorIcon },
  { navigatorKey: "RandomWallFollow", navigatorIcon: RandomWallFollowNavigatorIcon },
  { navigatorKey: "OpenSpaceWallFollow", navigatorIcon: OpenSpaceWallFollowNavigatorIcon },
  { navigatorKey: "SubZones", navigatorIcon: SubZonesNavigatorIcon },
  { navigatorKey: "WallFollow", navigatorIcon: WallFollowNavigatorIcon },
  { navigatorKey: "SpotCleaning", navigatorIcon: SpotCleaningNavigatorIcon },
  { navigatorKey: "DemoMode", navigatorIcon: DemoModeNavigatorIcon },
  { navigatorKey: "RepeatPathDemo", navigatorIcon: RepeatPathDemoNavigatorIcon },
];

export const NavigatorDetailsTooltipTitle: React.FC<{ navigator: string }> = ({ navigator }) => {
  const navigatorDescription = getNavigatorDetailsDescriptionOrNull(navigator);
  if (navigatorDescription == null) {
    return null;
  }

  return (
    <Typography data-testid="navigatorTooltipDescription">{navigatorDescription}</Typography>
  );
};

export const NavigatorMenuItem: React.FC<{ navigator: RswNavigator, onClick: (newNavigator: string) => void, selected: boolean, label?: string }> = ({ navigator, onClick, selected, label }) => {

  const Item = (
    <Stack alignItems="center" width="100%" spacing={2}>
      {navigatorToNavigatorIconMap.find((n) => n.navigatorKey === navigator.name)?.navigatorIcon != null && (
        <img
          src={navigatorToNavigatorIconMap.find((n) => n.navigatorKey === navigator.name)?.navigatorIcon}
          alt={navigator.name}
          style={{ width: "48px", height: "48px" }}
        />
      )}
      <Typography variant="subtitle2" whiteSpace="wrap" textAlign="center">
        {label ?? getNavigatorDescription(navigator)}
      </Typography>
    </Stack>
  );

  return (
    <MenuItem
      key={navigator.name}
      value={navigator.name}
      sx={(theme) => ({
        minWidth: "148px",
        flex: "1 1 50%",
        minHeight: theme.spacing(20),
        overflow: "hidden",
        position: "relative",
        p: 1,
        boxShadow: selected ? "inset 0 0 8px rgba(0,0,0,0.5)" : undefined,
        color: selected ? theme.palette.primary.main : undefined,
      })}
      onClick={() => onClick(navigator.name)}
    >
      {navigator.availability === NavigatorAvailability.Public &&
        getNavigatorDetailsDescriptionOrNull(navigator.name) != null ? (
        <Tooltip title={<NavigatorDetailsTooltipTitle navigator={navigator.name} />} placement="bottom">
          {Item}
        </Tooltip>
      ) : (
        Item
      )}
    </MenuItem>
  );
};